import * as tslib_1 from "tslib";
import { getStore as getFavoritesStore } from 'owa-favorites';
import { IsGroupsEnabled } from 'owa-group-feature-flags';
import { lazyLoadGroups, lazyLoadGroupsFromSessionData, lazyLoadUnifiedGroupsSettings, } from 'owa-group-left-nav-actions';
import { getGroupsStore } from 'owa-groups-shared-store';
import { loadFavorites } from 'owa-favorites';
import { initializeFavoritePersonas, outlookFavoritePersonasLoaded, } from 'owa-mail-favorites-store';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { selectDefaultFolder } from 'owa-mail-folder-forest-actions';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import folderStore from 'owa-folders';
import { action } from 'satcheljs/lib/legacy';
import { loadMailFolders } from 'owa-mail-folder-store';
/**
 * Load the folder forest to stores, i.e. folders and favorites
 */
export default action('loadFolderForest')(function loadFolderForest() {
    loadMailFolders();
    loadFavorites();
    if (isControlFeatureEnabled('tri-favorites-roaming')) {
        onOutlookFavoritesLoaded();
    }
    else {
        onFavoritesLoaded();
    }
    // Check that what we have selected is actually a valid node,
    // not an old one that has been removed.
    if (!isSelectedNodeValid()) {
        // Otherwise selected the default one (inbox).
        selectDefaultFolder();
    }
    if (IsGroupsEnabled()) {
        lazyLoadGroupsFromSessionData.importAndExecute(getGroupsStore());
        lazyLoadGroups.importAndExecute(getGroupsStore());
        lazyLoadUnifiedGroupsSettings.importAndExecute();
    }
});
function isSelectedNodeValid() {
    var selectedNode = getSelectedNode();
    var isValid = false;
    switch (selectedNode.type) {
        case 0 /* Folder */:
        case 1 /* Persona */:
        case 5 /* PrivateDistributionList */:
            var selectedFolderId = selectedNode.id;
            var folder = selectedFolderId
                ? folderStore.folderTable.get(selectedFolderId)
                : null;
            isValid = folder != null;
            break;
        case 2 /* Group */:
            isValid = true;
            break;
        default:
            break;
    }
    return isValid;
}
/**
 * Called on favorites loaded in store
 */
function onFavoritesLoaded() {
    var favoritesStore = getFavoritesStore();
    var favoritePersonaNodes = favoritesStore.favoritesPersonaNodes;
    if (favoritePersonaNodes.size > 0) {
        initializeFavoritePersonas(tslib_1.__spread(favoritePersonaNodes.values()).map(function (persona) { return persona.id; }));
    }
}
/**
 * Called on Outlook favorites loaded in store
 */
function onOutlookFavoritesLoaded() {
    var favoritesStore = getFavoritesStore();
    var outlookFavoritePersonas = favoritesStore.outlookFavoritePersonas;
    var outlookFavoritePdls = favoritesStore.outlookFavoritePrivateDistributionLists;
    if (outlookFavoritePersonas.size > 0 || outlookFavoritePdls.size > 0) {
        var personaAndPdlFavorites = tslib_1.__spread(outlookFavoritePersonas.values(), outlookFavoritePdls.values());
        outlookFavoritePersonasLoaded(personaAndPdlFavorites);
    }
}
//# sourceMappingURL=loadFolderForest.js.map